import React from "react";
import styles from "./styles.css";
import Car from "./images/car.png";
import Tips from "./images/tips.png";
import TransparentButton from "../button/transparent-button";
import ArrowIcon from "../arrow";
import PropTypes from "prop-types";
import LazyImage from "../../shared/lazy-image";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";

const SellUsedCarDocuments = ({
    heading = "",
    buttonText = "",
    isTipsToSellUsedCars = false,
    gaEventCallback = () => {},
    genericContent = {}
}) => {
    const { imageContent = "", secondaryContent = "" } = genericContent || {};
    const imgSrc = isTipsToSellUsedCars ? Tips : Car;
    const altTitle = isTipsToSellUsedCars ? "car tips" : "car documents";
    const htmlContent = isTipsToSellUsedCars ? secondaryContent : imageContent;

    const handleClick = async () => {
        await yieldToMain();
        gaEventCallback();
        window.scrollTo(0, 0);
    };

    return (
        <div styleName={"styles.documentWrapper"}>
            <div styleName={"styles.titleSection"}>
                <h3>{heading}</h3>
                <LazyImage src={imgSrc} alt={altTitle} />
            </div>
            <div
                styleName={"styles.documentList"}
            >
                <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                <div styleName={"styles.btn"} onClick={handleClick}>
                    <TransparentButton text={buttonText} />
                    <ArrowIcon/>
                </div>
            </div>
        </div>
    );
};

SellUsedCarDocuments.propTypes = {
    heading: PropTypes.string,
    buttonText: PropTypes.string,
    isTipsToSellUsedCars: PropTypes.bool,
    gaEventCallback: PropTypes.func,
    genericContent: PropTypes.object
};

export default SellUsedCarDocuments;
